import { proxy } from 'valtio'

const uiState = proxy({
  homepage: {
    visible: true,
    data: {
      zh: {
        title: `「用真誠的感恩之心，重新連結後疫情時代的我們。」`,
        content: `2019年末之際，COVID-19疫情猝不及防地席捲全球，帶來前所未有的巨變，生命消逝、政經動盪，在病毒肆意蔓延的同時，孤寂、恐懼、焦慮隨之擴散，在人們心中留下難以抹滅的痕跡。
</br>
</br>
當疫情為地球按下暫停鍵，同時也帶來省思的契機，面對大地生靈之殤，我們是否應該放下人類的傲慢，重新思索與天地萬物的和平共存之道？
</br>
</br>
2022一年之初，在世界紛擾中靜下心來，於歷史文明中反觀自省，從淵源流長的茶文化裡，探索面對無常的勇氣，學習療癒傷痕的智慧。在生命陷落之處，以感謝所有取代喟嘆失去，用感恩之心修復支離破碎的身心創傷，化殘為美，邁向後疫情時代的重生之路。`
      },
      en: {
        title: `"With a Sincere Sense of Gratitude,
Let's Reconnect with Each Other in the Post-Pandemic Era. "`,
        content: `At the end of 2019, the COVID-19 pandemic suddenly struck the world and caused unforeseeable changes. Lives passed away; social and political conditions were in great turmoil. With the virus infecting more and more people around the world, feelings of loneliness, fear, and anxiety proliferated and left behind indelible marks on people’s minds.
</br>
</br>
As the pandemic pressed the pause button for the world, it also brought about an opportunity for deep reflection. Faced with unprecedented suffering around the world, shouldn’t we let go of our arrogance as humans and figure out ways to live harmoniously with all beings of the universe?
</br>
</br>
In the beginning of 2022, let’s calm down in this turbulent world and reflect on our history and civilization. Let’s dive into the long tradition of tea culture, discover the courage to face impermanence, and acquire the wisdom to heal our pains. When life falls apart, let’s give thanks to all beings instead of lamenting the loss. Let’s fix the sores on our bodies and in our minds with gratitude. When we can see perfection in flaws, we will be on the path of regeneration in the post-pandemic era.`
      }
    }
  }
})

export default uiState
